import { Box, Dialog, IconButton, Portal, Stack, Typography } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close';

const EvismartAppQrPopup = ({isOpen, handleClose}) => {
  return (
    <Portal>
        <Dialog 
            open={isOpen} 
            onClose={handleClose} 
            maxWidth="md"
            PaperProps={{
                sx: { 
                    width: 580, 
                    borderRadius: "20px",
                    paddingY: "79px",
                    paddingX: "42px",
                    backgroundImage: 'url("https://storageevidentwebprodeas.blob.core.windows.net/hub/AppPopupBG.c3dacf578f56576bb77c.png")',
                    backgroundSize: 'cover',
                    backgroundColor: 'transparent'
                }
            }}
        >
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon sx={{
                            width: "28px",
                            height: "28px"
                        }} 
                    />
                </IconButton>
            <Box 
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    columnGap: "20px"
                }}
            >
                <Box sx={{display: 'flex', alignItems: 'center', width: "100%"}}>
                    <Box sx={{display: 'flex',flexDirection: 'column'}}>
                        <Stack
                            sx={{
                                marginBottom: "30px"
                            }}
                        >
                            <Box sx={{display: "flex", justifyContent: "center", marginBottom: "12px"}}>
                                <img src="https://storageevidentwebprodeas.blob.core.windows.net/hub/EviSmartLogo2.png" alt="EviSmart App Logo" />
                            </Box>
                            <Box sx={{ paddingX: "20px"}}>
                                <Typography 
                                    variant="h1" 
                                    component="h1"
                                    sx={{
                                        fontSize: "32px",
                                        textAlign: "center",
                                        fontWeight: 700,
                                        marginBottom: "12px",
                                        color: "#FFFFFF"
                                    }}
                                >
                                    Reduce remakes by 90%
                                </Typography>
                            </Box>
                            <Box>
                                <Typography variant="body1" textAlign="center" color="white" fontWeight="400">
                                    Scan QR code to download the app
                                </Typography>
                            </Box>
                        </Stack>
                        <Stack>
                            <Box sx={{display: "flex", justifyContent: "center", marginBottom: "30px"}}>
                                <img style={{width:'147px'}} src="https://storageevidentwebprodeas.blob.core.windows.net/hub/AppQRRedirect.png" alt="Scan QR Code" />
                            </Box>
                            <Box sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    columnGap: "10px"
                                }}
                            >
                                <a href="https://apps.apple.com/app/evismart-app/id6737177426"><img src="https://storageevidentwebprodeas.blob.core.windows.net/hub/AppStoreLogo.png" alt="Download on App Store" /></a>
                                <a href="https://play.google.com/store/apps/details?id=com.evidentdigital.evident"><img src="https://storageevidentwebprodeas.blob.core.windows.net/hub/PlayStoreLogo.png" alt="Download on Play Store" /></a>
                                
                            </Box>
                        </Stack>
                    </Box>
                    
                </Box>
                <Box>
                    <img src="https://storageevidentwebprodeas.blob.core.windows.net/hub/phone_preview.c4f41a3780784f8de398.png" alt="EviSmart App" />
                </Box>
            </Box>
        </Dialog>
    </Portal>
  )
}

export default EvismartAppQrPopup